import { publish } from '@core/constants/customEvents';
import { ButtonFactory } from './buttonRegistryFactory';

const createSignatureRibbonButton: ButtonFactory = () => {
  return {
    key: 'buttonSignature',
    unlocalizedText: 'Insert Signature',
    iconName: 'InsertSignatureLine',
    onClick: async () => {
      publish('evodicom.report.insertSignature', undefined);
    },
  };
};

export default createSignatureRibbonButton;
